<template>
    <div class="aspect-ratio" :style="'padding-top: ' + paddingTopStyle" @click="checkHander" role="button">
        <div class="aspect-ratio-inner">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: "AspectRatio",
  props: ["ratioWidth", "ratioHeight"],
  methods: {

  },
  computed: {
      paddingTopStyle: function () {
          let xFloat = parseFloat(this.ratioWidth);
          let yFloat = parseFloat(this.ratioHeight);
          if (xFloat && yFloat) {
              let percentage = yFloat / xFloat * 100;
              return percentage.toFixed(2) + "%";
          }
          return "100%"; //Default if invalid inputs
      },
  }
 
};
</script>